import { useParams, useSearchParams } from 'react-router-dom';

import { RunTypeIcon } from '@/components/RunTypeIcon';

import { Breadcrumb } from '../../components/Breadcrumbs';
import { useRootRunAndRun } from './utils/useRootRunAndRun';

export function RunCrumb(props: { isActive?: boolean }) {
  const { runId } = useParams();
  const [searchParams] = useSearchParams();
  const traceId = searchParams.get('trace_id') ?? undefined;
  const { rootRun, run } = useRootRunAndRun(traceId, runId);
  const hasEllipsis = (run?.data?.parent_run_ids?.length ?? 0) > 1;

  const runList = [rootRun ?? undefined, hasEllipsis ? null : undefined];
  if (rootRun?.id !== runId && run.data) {
    runList.push(run.data);
  }

  return (
    rootRun &&
    run.data &&
    runList.map((runOrEllipsis) => {
      if (runOrEllipsis === undefined) {
        return null;
      }
      if (runOrEllipsis === null) {
        return <Breadcrumb key="ellipsis" path="#" name="..." />;
      }
      const { id, name, app_path, run_type } = runOrEllipsis;

      return (
        <Breadcrumb
          key={id}
          path={app_path}
          icon={<RunTypeIcon className="size-4" run={{ name, run_type }} />}
          name={name}
          isActive={id === runId && props.isActive}
        />
      );
    })
  );
}
